
import React, { useState, useEffect } from 'react';
import { Lesson } from '../data/lessons';
import analytics from '@/utils/analytics';
import LessonHeader from './daily-content/LessonHeader';
import LessonContent from './daily-content/LessonContent';
import ActionStep from './daily-content/ActionStep';
import MoodTracker from './daily-content/MoodTracker';
import SymptomsTracker from './daily-content/SymptomsTracker';
import KeyTakeaway from './daily-content/KeyTakeaway';

// Initialize the global variable if not already set
if (typeof window !== 'undefined' && !window.selectedSymptoms) {
  window.selectedSymptoms = [];
}

interface DailyContentProps {
  lesson: Lesson;
}

const DailyContent: React.FC<DailyContentProps> = ({ lesson }) => {
  const [moodRating, setMoodRating] = useState<number | null>(null);
  const [localSelectedSymptoms, setLocalSelectedSymptoms] = useState<string[]>([]);
  const [tipRating, setTipRating] = useState<'up' | 'down' | null>(null);
  
  // Update global selectedSymptoms whenever local state changes
  useEffect(() => {
    window.selectedSymptoms = localSelectedSymptoms;
  }, [localSelectedSymptoms]);
  
  return (
    <div className="space-y-6 animate-slide-up">
      <LessonHeader 
        day={lesson.day} 
        title={lesson.title} 
        subtitle={lesson.subtitle} 
      />
      
      <LessonContent 
        content={lesson.content} 
        quote={lesson.quote} 
        quoteAuthor={lesson.quoteAuthor} 
      />
      
      <ActionStep 
        title={lesson.actionStep.title}
        description={lesson.actionStep.description}
        tipRating={tipRating}
        setTipRating={setTipRating}
        lessonDay={lesson.day}
      />
      
      <MoodTracker 
        lessonDay={lesson.day}
        moodRating={moodRating}
        setMoodRating={setMoodRating}
      />
      
      <SymptomsTracker 
        selectedSymptoms={localSelectedSymptoms}
        setSelectedSymptoms={setLocalSelectedSymptoms}
      />
      
      <div className="space-y-4 pt-2">
        <KeyTakeaway />
      </div>
    </div>
  );
};

export default DailyContent;
